"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteChannelsStore = exports.LocalChannelsStore = void 0;
var channelsApi = __importStar(require("./channelsApi"));
var projectsApi = __importStar(require("./projectsApi"));
// Note: We don't need to actually save a channel for local storage.
// However, we want to make a best effort to keep track of the original local storage
// key when switching levels, so we store it here.
var LocalChannelsStore = /** @class */ (function () {
    function LocalChannelsStore() {
        this.localStorageKey = undefined;
    }
    LocalChannelsStore.prototype.load = function (key) {
        this.localStorageKey = key;
        return Promise.resolve({});
    };
    // We don't support changing keys for local storage, so we just return the
    // existing key, if we have one. If we don't have one, we return a default key.
    LocalChannelsStore.prototype.loadForLevel = function () {
        var key = this.localStorageKey || 'savedCodeLocal';
        return Promise.resolve(new Response("{channel: ".concat(key, "}")));
    };
    LocalChannelsStore.prototype.save = function () {
        return Promise.resolve(new Response(''));
    };
    LocalChannelsStore.prototype.redirectToRemix = function () {
        // Remix is not supported for local storage.
    };
    LocalChannelsStore.prototype.publish = function () {
        // Publishing is not supported for local storage.
        return Promise.resolve(new Response(''));
    };
    LocalChannelsStore.prototype.unpublish = function () {
        // Unpublishing is not supported for local storage.
        return Promise.resolve(new Response(''));
    };
    return LocalChannelsStore;
}());
exports.LocalChannelsStore = LocalChannelsStore;
var RemoteChannelsStore = /** @class */ (function () {
    function RemoteChannelsStore() {
        this.defaultChannel = { name: 'New Project' };
    }
    RemoteChannelsStore.prototype.loadForLevel = function (levelId, scriptId) {
        return projectsApi.getChannelForLevel(levelId, scriptId);
    };
    RemoteChannelsStore.prototype.load = function (channelId) {
        return channelsApi.get(channelId);
    };
    RemoteChannelsStore.prototype.save = function (channel) {
        channel = __assign(__assign({}, this.defaultChannel), channel);
        return channelsApi.update(channel);
    };
    RemoteChannelsStore.prototype.redirectToRemix = function (channel) {
        projectsApi.redirectToRemix(channel.id, channel.projectType);
    };
    RemoteChannelsStore.prototype.publish = function (channel) {
        return channelsApi.publish(channel);
    };
    RemoteChannelsStore.prototype.unpublish = function (channel) {
        return channelsApi.unpublish(channel);
    };
    return RemoteChannelsStore;
}());
exports.RemoteChannelsStore = RemoteChannelsStore;
